import React from "react";
import "./About.css";
import about1 from "../../../images/about/solutions/1.jpg";
import about2 from "../../../images/about/solutions/2.png";
import about3 from "../../../images/about/solutions/3.png";

function About() {
  return (
    <div id="rs-about" className="rs-about style10 gray-bg5 p-5">
      <div className="" style={{ width: "90%", margin: "auto" }}>
        <div className="row">
          <div className="col-lg-6 pr-70 md-pr-15 md-mb-50">
            <div className="sec-title4 mb-30">
              <span className="sub-title new pb-10">About Us</span>
              <h2 className="title pb-20">
                An Exceptionally unique experience Tailored to you
              </h2>
              <p className="margin-0">
                In a professional context it often happens that private or
                corporate clients order a publication news while still not being
                ready.
              </p>
            </div>
            <div id="accordion" className="accordion">
              <div className="card">
                <div className="card-header">
                  <a
                    className="card-link"
                    data-toggle="collapse"
                    href="#collapseOne"
                  >
                    Our Customer
                  </a>
                </div>
                <div
                  id="collapseOne"
                  className="collapse show"
                  data-parent="#accordion"
                >
                  <div className="card-body">
                    Business advisory service advises current and future
                    businesses prospects of a client, with the aim of
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">
                  <a
                    className="collapsed card-link"
                    data-toggle="collapse"
                    href="#collapseTwo"
                  >
                    Our Services
                  </a>
                </div>
                <div
                  id="collapseTwo"
                  className="collapse"
                  data-parent="#accordion"
                >
                  <div className="card-body">
                    Business advisory service advises current and future
                    businesses prospects of a client, with the aim of
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-content">
              <div className="images-part">
                <img src={about1} alt="Images" />
              </div>
              <div className="rs-animations">
                <div className="spinner dot">
                  <img className="scale" src={about2} alt="Images" />
                </div>
                <div className="spinner ball">
                  <img className="dance2" src={about3} alt="Images" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
